import { isString } from './utilities/inspect';
const selectorRegex = /^([#|\.]|path)/i;
export function getPath(selector) {
    if (isString(selector)) {
        if (!selectorRegex.test(selector)) {
            return selector;
        }
        selector = document.querySelector(selector);
    }
    return selector.getAttribute('d');
}
